module.exports = __webpack_public_path__ + "static/media/user-circle.1a7fb8c8.svg";